<style scoped>

</style>
<template>
  <ViewerItem
    v-if="contract.id"
    type="Contract"
    :model_id="contract.id"
    class="link"
  >
    <slot :contract="contract">
      {{ contract.uid }}
    </slot>
  </ViewerItem>
  <span v-else>无</span>
</template>
<script>
  import ContractUtil from '../libs/util';
  import ViewerItem from '../../components/viewer/item';

  export default {
    components: { ViewerItem },
    props: {
      id: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        loading: false,
        failed: false,
        contract: {}
      }
    },
    computed: {
      //
    },
    created() {
      this.init();
    },
    mounted() {
      //
    },
    methods: {
      init() {
        if (!this.id) return;
        if (this.loading) return;
        this.loading = true;
        this.failed = false;
        ContractUtil.find(this.id)
          .then((data) => {
            this.contract = data.contract;
          }).catch((e) => {
            console.warn(e);
            this.failed = true;
          }).finally(() => {
            this.loading = false;
          })
      }
    }
  }
</script>
